import { useCallback } from "react";
import { Dropdown } from "semantic-ui-react";

/**
 * Builds an array of Custom Fields.
 * The result maintains all existing custom fields while updating the selection state
 * of fields in the selected group.
 * @param {Object} params
 * @param {Array<Object>} params.customFieldGroups
 * @param {Array<Object>} params.customFieldConfigs
 * @param {string} params.selectedCustomFieldGroupID
 * @returns {Array<Object>}
 */
export const buildCustomFields = ({
  customFieldGroups = [],
  customFieldConfigs = [],
  selectedCustomFieldGroupID,
}) => {
  const selectedGroup = customFieldGroups.find(
    cfg => cfg.id == selectedCustomFieldGroupID
  ).custom_field_configs;
  const selectedGroupMap = selectedGroup.reduce((map, field) => {
    map[field.id] = field;
    return map;
  }, {});

  return customFieldConfigs.map(customFieldConfig => {
    if (selectedGroupMap[customFieldConfig.id]) {
      return {
        ...customFieldConfig,
        selected: true,
      };
    }
    return {
      ...customFieldConfig,
      selected: customFieldConfig.selected || customFieldConfig.required,
    };
  });
};

export default function CustomFieldGroupDropdown({
  customFieldGroups = [],
  onCustomFieldGroupSelect,
  customFieldConfigs,
}) {
  const dropdownOptions = customFieldGroups.map(cf => ({
    id: cf.id,
    value: cf.id,
    text: cf.name,
  }));

  const handleCustomFieldGroupSelect = useCallback(
    (_, data) => {
      const customFields = buildCustomFields({
        customFieldGroups,
        customFieldConfigs,
        selectedCustomFieldGroupID: data.value,
      });
      onCustomFieldGroupSelect(customFields);
    },
    [customFieldGroups, customFieldConfigs, onCustomFieldGroupSelect]
  );

  return (
    <Dropdown
      className="button icon tiny cf-dropdown"
      basic
      floating
      labeled
      search
      icon="plus"
      text="Custom Field Groups"
      name="customFieldGroups"
      options={dropdownOptions}
      value={null}
      onChange={handleCustomFieldGroupSelect}
      selectOnBlur={false}
    />
  );
}
